import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfigService } from '../../_services/config.service';
import { ToastService } from "../../_services/toast.service";

@Component({
  selector: "app-config",
  templateUrl: "./config.component.html",
  styleUrls: ["./config.component.css"],
})

export class ConfigComponent implements OnInit {
  configForm: FormGroup;
  configs: any[] = [];
  editMode = false;
  currentConfigId: number;

  constructor(private fb: FormBuilder, private configService: ConfigService, private toast: ToastService) {}
  ngOnInit(): void {
    this.loadConfigs();

    this.configForm = this.fb.group({
      key: ['', Validators.required],
      value: ['', Validators.required]
    });
  }

  loadConfigs() {
    this.configService.getConfigs().subscribe(
      data => {
        this.configs = data;
      },
      error => {
        this.toast.error('Erreur lors du chargement des configurations');
        console.error('Erreur lors du chargement des configurations', error);
      }
    );
  }

  onSubmit() {
    if (this.editMode) {
      this.configService.updateConfig(this.currentConfigId, this.configForm.value).subscribe(
        () => {
          this.toast.success('Configuration mise à jour avec succès');
          this.loadConfigs();
          this.resetForm();
        },
        error => {
          this.toast.error('Erreur lors de la mise à jour de la configuration');
          console.error('Erreur lors de la mise à jour de la configuration', error);
        }
      );
    } else {
      this.configService.createConfig(this.configForm.value).subscribe(
        () => {
          this.toast.success('Configuration créée avec succès');
          this.loadConfigs();
          this.resetForm();
        },
        error => {
          this.toast.error('Erreur lors de la création de la configuration');
          console.error('Erreur lors de la création de la configuration', error);
        }
      );
    }
  }

  onEdit(config: any) {
    this.editMode = true;
    this.currentConfigId = config.id;
    this.configForm.patchValue({
      key: config.key,
      value: config.value
    });
  }

  onCancel() {
    this.resetForm();
  }

  onDelete(id: number) {
    if (confirm('Êtes-vous sûr de vouloir supprimer cette configuration?')) {
      this.configService.deleteConfig(id).subscribe(
        () => {
          this.toast.success('Configuration supprimée avec succès');
          this.loadConfigs();
        },
        error => {
          this.toast.error('Erreur lors de la suppression de la configuration');
          console.error('Erreur lors de la suppression de la configuration', error);
        }
      );
    }
  }

  resetForm() {
    this.editMode = false;
    this.configForm.reset();
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_components/config/config.component.ts